export enum ActionTypes {
  LOAD_ALERT_SETTING_REQUEST = "LOAD_ALERT_SETTING_REQUEST",
  LOAD_ALERT_SETTING_SUCCEEDED = "LOAD_ALERT_SETTING_SUCCEEDED",
  LOAD_ALERT_SETTING_FAILED = "LOAD_ALERT_SETTING_FAILED",

  UPDATE_ALERT_SETTING_REQUEST = "UPDATE_ALERT_SETTING_REQUEST",
  UPDATE_ALERT_SETTING_END = "UPDATE_ALERT_SETTING_END",

  LOAD_DEVICE_STATUS_SUBSCRIPTION_REQUEST = "LOAD_DEVICE_STATUS_SUBSCRIPTION_REQUEST",
  LOAD_DEVICE_STATUS_SUBSCRIPTION_SUCCEEDED = "LOAD_DEVICE_STATUS_SUBSCRIPTION_SUCCEEDED",
  LOAD_DEVICE_STATUS_SUBSCRIPTION_FAILED = "LOAD_DEVICE_STATUS_SUBSCRIPTION_FAILED",

  UPDATE_DEVICE_STATUS_SUBSCRIPTION_REQUEST = "UPDATE_DEVICE_STATUS_SUBSCRIPTION_REQUEST",
  UPDATE_DEVICE_STATUS_SUBSCRIPTION_END = "UPDATE_DEVICE_STATUS_SUBSCRIPTION_END",
}

export default ActionTypes;
